export default __webpack_public_path__ + "static/media/kyc.300260c0.png";